import { cn } from '@/lib/utils'

interface LoadingScreenProps {
  message?: string
  className?: string
}

export default function LoadingScreen({ message, className }: LoadingScreenProps) {
  return (
    <div className={cn(
      'fixed inset-0 flex flex-col items-center justify-center bg-background',
      className
    )}>
      {/* Spinner animado con los colores de Francia */}
      <div className="relative w-16 h-16 mb-4">
        <div className="absolute inset-0 rounded-full border-4 border-t-[#0055A4] border-r-white border-b-[#EF4135] border-l-transparent animate-spin" />
      </div>

      {/* Logo o título */}
      <h1 className="text-2xl font-bold text-primary mb-2">
        Nomad<span className="text-[#EF4135]">Lexis</span>
      </h1>

      {/* Mensaje de carga */}
      {message && (
        <p className="text-muted-foreground animate-pulse">
          {message}
        </p>
      )}

      {/* Puntos animados */}
      <div className="flex gap-1 mt-4">
        <div className="w-2 h-2 bg-[#0055A4] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-white border border-gray-200 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 bg-[#EF4135] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  )
}
